// SPDX-License-Identifier: LicenseRef-Proprietary
import React, { useState } from 'react';
import { AuthService } from '../../services/authService';
import { LogoutButton } from './LogoutButton';

interface UserProfileProps {
  className?: string;
}

export const UserProfile: React.FC<UserProfileProps> = ({ className = '' }) => {
  const [authEnabled, setAuthEnabled] = useState<boolean | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  React.useEffect(() => {
    (async () => {
      const enabled = await AuthService.isAuthEnabled();
      setAuthEnabled(enabled);
      if (!enabled) return;
      // Check if user is authenticated
      try {
        const status = await AuthService.fetchStatus();
        setIsAuthenticated(status?.authenticated ?? false);
      } catch {
        setIsAuthenticated(false);
      }
    })();
  }, []);

  // Show loading state while checking auth
  if (authEnabled === null) {
    return null;
  }

  // In development mode, show logout button
  if (!authEnabled) {
    return (
      <div className={`user-profile ${className}`}>
        <LogoutButton />
      </div>
    );
  }

  // Not authenticated - don't show anything
  if (!isAuthenticated) {
    return null;
  }

  // Authenticated - just show the Sign Out button
  return (
    <div className={`user-profile ${className}`}>
      <LogoutButton />
    </div>
  );
};
